// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Global administrators use Data Restore alongside other system
 * operations pages. This route supplies their shared background and content
 * width, while DataRestoreManager supplies the restore heading and controls;
 * rendering another header here would give one destructive workflow two
 * competing titles.
 */
import { DataRestoreManager } from '../components/DataRestoreManager';

export default function DataRestorePage() {
  return (
    <div className="min-h-full bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <DataRestoreManager />
      </div>
    </div>
  );
}
